// extracted by mini-css-extract-plugin
export default {"dragHandleIconContainer":"AccessoryDragIndicator_dragHandleIconContainer__t5MaM","iconWrapper":"AccessoryDragIndicator_iconWrapper__lhEQg"};